import {handleVC2MessageReceived} from './commsHelpers';

const CONSTS = require('../constants/communications');
let currentWsUrl;

class CommsClient {
    constructor(wsUrl) {
        currentWsUrl = wsUrl;
        this._openWebsocket();
    }

    addCallbacks(options = {}) {
        // init operator?
        this._addCallback('initCallback', options);
        // VC2 PRE
        this._addCallback('setEventsMessageCallback', options);
        this._addCallback('videoFinishedPlayingMessageCallback', options);
        this._addCallback('noMoreBetsMessageCallback', options);
        this._addCallback('noMoreBetsEndedMessageCallback', options);
        this._addCallback('setNextEventsTimestampCallback', options);
        this._addCallback('setGameControllerState', options);
        this._addCallback('errorCallback', options);
    }

    _addCallback(callbackName, options) {
        if (options[callbackName]) {
            this['_' + callbackName] = options[callbackName];
        } else {
            throw new Error(CONSTS.LOGS.ERROR_MISSING_START_PARAMETERS);
        }
    }

    _onMessage(msg) {
        let data = handleVC2MessageReceived(msg.data);

        if (!data || !data.customer) {
            return;
        }

        // let queuedEvent = null; Check explicit error message
        let errorMessage = data.error;
        if (errorMessage) {
            // This error is related to PLATFORM_EVENT errors
            let lastCall = this._commsQueue.getLastCommandSent();
            this._commsQueue.clear();
            // logger.debug1(CONSTS.LOGS.RECEIVED_ERROR, data);
            return this._errorCallback(CONSTS.PROTOCOL.ERROR_FAULT_CODE, errorMessage.faultCode, lastCall.params.GAME_ID);
        }

        // check if the received message is valid
        if (data.channel !== undefined) {
            if (data.type === CONSTS.VC2_MESSAGE_TYPE.VID) {
                if (data.event.resulted !== undefined && data.event.resulted === true) {
                    this._setGameControllerState(data.channel, CONSTS.VC2_MESSAGE_TYPE.RESTD, undefined, undefined, data.event.eventTimeDate);
                } else {
                    this._setGameControllerState(data.channel, data.type, undefined, undefined, data.event.eventTimeDate);
                }
            } else {
                this._setGameControllerState(data.channel, data.type);
            }
        }
        switch (data.type) {
            case CONSTS.VC2_MESSAGE_TYPE.PRE:
                // when PRE is not the first message, video finished callback is evoked
                if (!data.next || data.next.length === 0) {
                    this._videoFinishedPlayingMessageCallback([], true, data.channel);
                }
                this._noMoreBetsEndedMessageCallback(data.channel);
                break;
            // case CONSTS.VC2_MESSAGE_TYPE.NMB:
            //   break;
            // case CONSTS.VC2_MESSAGE_TYPE.VID:
            //   break;
            // case CONSTS.VC2_MESSAGE_TYPE.RES:
            //   break;
            default:
                break;
        }
    }

    _connect(wsUrl) {
        this.vc2Socket = new WebSocket(wsUrl);

        this.vc2Socket.onmessage = this._onMessage.bind(this);

        this.vc2Socket.onclose = (event) => {
            // https://tools.ietf.org/html/rfc6455#section-7.4.1
            let reason;
            switch (event.code) {
                case 1000:
                    reason = 'Normal closure';
                    break;
                case 1001:
                    reason = 'An endpoint is "going away", such as a server going down or a browser having navigated away from a page.';
                    break;
                case 1002:
                    reason = 'Endpoint is terminating the connection due to protocol error';
                    break;
                case 1003:
                    reason = 'Endpoint is terminating the connection because it has received a type of data it cannot accept.';
                    break;
                case 1004:
                    reason = 'Reserved. The specific meaning might be defined in the future.';
                    break;
                case 1005:
                    reason = 'No status code was actually present.';
                    break;
                case 1006:
                    reason = 'The connection was closed abnormally, (e.g., without sending or receiving a Close control frame), trying to reopen now.';
                    this._closeWebsocket();
                    // attempt to reopen in 1 second
                    setTimeout(this._openWebsocket(), 1000);
                    break;
                case 1007:
                    reason = 'Endpoint is terminating the connection because it has received data within a message that was not consistent with the type of the message';
                    break;
                case 1008:
                    reason = 'Endpoint is terminating the connection because it has received a message that "violates its policy".';
                    break;
                case 1009:
                    reason = 'Endpoint is terminating the connection because it has received a message that is too big for it to process.';
                    break;
                case 1010:
                    reason = 'Endpoint is terminating the connection because it has expected the server to negotiate handshake.';
                    break;
                case 1011:
                    reason = 'A server is terminating the connection because it encountered an unexpected condition that prevented it from fulfilling the request.';
                    break;
                case 1015:
                    reason = 'The connection was closed due to a failure to perform a TLS handshake (e.g., the server certificate can\'t be verified).';
                    break;
                default:
                    reason = 'Unknown reason';
            }
            console.log('REASON: ', reason);

        };

        this.vc2Socket.onopen = () => {
            if (!this._isLoaded) {
                console.debug('websocket is open');
            }
        };
    }

    _openWebsocket() {
        this._connect(currentWsUrl);

    }

    _closeWebsocket() {
        if (this.vc2Socket) {
            this.vc2Socket.close();
            this.vc2Socket = undefined;
        }
    }
}

// Singleton
export default CommsClient;



// WEBPACK FOOTER //
// ./src/communications/commsClient.js